import { render, staticRenderFns } from "./table-today-basketball.vue?vue&type=template&id=09d11d8c&scoped=true"
import script from "./table-today-basketball.vue?vue&type=script&lang=js"
export * from "./table-today-basketball.vue?vue&type=script&lang=js"
import style0 from "./table-today-basketball.vue?vue&type=style&index=0&id=09d11d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d11d8c",
  null
  
)

export default component.exports